import { Action, combineReducers, Reducer, ReducersMapObject } from 'redux'
import { IActionsCreators } from '../../interfaces/action'
import { IStore } from '../../interfaces/store'

import locale from './locale'
import user from './user'
import allExistingActiveSubscriptions from './subscription'

const reducers: ReducersMapObject<IStore, Action<IActionsCreators>> = {
	user,
	locale,
	allExistingActiveSubscriptions
}

export const Reducers: Reducer<
	IStore,
	Action<IActionsCreators>
> = combineReducers(reducers)
